import { render, staticRenderFns } from "./DotsSVG.vue?vue&type=template&id=4c48bdea&scoped=true&"
import script from "./DotsSVG.vue?vue&type=script&lang=js&"
export * from "./DotsSVG.vue?vue&type=script&lang=js&"
import style0 from "./DotsSVG.vue?vue&type=style&index=0&id=4c48bdea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c48bdea",
  null
  
)

export default component.exports